function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgPhp = function SvgPhp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,0v256L74.98,437.02C121.307,483.346,185.307,512,256,512c141.384,0,256-114.616,256-256 S256,0,256,0z"
  }), React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M256,0C185.307,0,121.307,28.654,74.98,74.98C137.79,137.79,160.087,160.088,256,256h256 C512,114.616,397.384,0,256,0z"
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "175.291,256 144.027,241.294 160.676,211.015 126.726,217.51 122.424,183.213  98.776,208.437 75.129,183.213 70.826,217.51 36.877,211.014 53.526,241.294 22.261,256 53.526,270.706 36.877,300.985  70.829,294.491 75.128,328.787 98.776,303.563 122.424,328.787 126.726,294.491 160.674,300.986 144.026,270.707  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "68.273,100.174 78.677,114.717 95.722,109.318 85.104,123.706 95.508,138.249  78.542,132.598 67.925,146.985 68.058,129.105 51.093,123.453 68.141,118.054  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "68.273,365.015 78.677,379.558 95.722,374.158 85.104,388.547 95.508,403.09  78.542,397.439 67.925,411.826 68.058,393.946 51.093,388.294 68.141,382.895  "
  }), React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "216.666,232.595 206.263,247.138 189.217,241.737 199.835,256.126 189.431,270.67  206.397,265.018 217.015,279.405 216.881,261.526 233.846,255.874 216.799,250.475  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PHP.b10798a5.svg";
export { ForwardRef as ReactComponent };